var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-chip-group',{attrs:{"active-class":"primary--text","column":""}},_vm._l((_vm.tags),function(tag){return _c('v-chip',{key:tag.id,on:{"click":function($event){return _vm.selecionar(tag)}}},[_vm._v(" "+_vm._s(tag.nome)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }